//=====================================================
//　G900：ＬINEログイン
//=====================================================
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { useEffect,useContext } from "react";
import { CtxAuth, CtxPatientInfo, CtxSystemErr } from "../../utils/Contexts";
import { AxiosResponse } from "axios";
import { ConstMsg } from "../../utils/ConstMsg";

export function G900(){

    const cua = useContext(CtxAuth);
    const history = useHistory();
    const search = useLocation().search;
    const cpi = useContext(CtxPatientInfo);
    const cserr = useContext(CtxSystemErr);

    const query2 = new URLSearchParams(search);
    const clinicId = query2.get("d_name") || "";
    const patientId = query2.get("login_id") || "";
    const password = query2.get("password") || "";
    const hash = query2.get("hash")==='true'?true:false;

    useEffect(
        function () {
            if(hash){ 
                cua.logout(); 
                cua.linelogin( 
                    clinicId,
                    patientId, 
                    password, 
                    function( res:AxiosResponse<any> ){
                        if( res.status === 200 ){
                            let errMess = cpi.getData(clinicId, patientId);
                            if(errMess){
                                history.push('/error') ;
                            }else{
                                history.push('/mypage') ;
                            }
                        }else{
                            if (res?.data) {
                                cserr.setErrmess(res?.data.message);
                            } else {
                                cserr.setErrmess(ConstMsg.EG9990001);
                            }
                        }
                    }
                );
            }else{
                cserr.setErrmess(ConstMsg.EG9990001);
            }
            // エラーメッセージを更新するため、cserrは第2引数から除外する
            // eslint-disable-next-line react-hooks/exhaustive-deps
        },[search]
    );

    return null;
}